module.exports = __webpack_public_path__ + "static/img/mpm_1.00b5e94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpm_1.jpg
// module id = PHAz
// module chunks = 1